import { supabase } from "@/lib/supabase/supabaseClient";
import { GetOrganisationQuestionsProps } from ".";

export const getOrganisationQuestions = async ({ crm_id, organisation_id }: GetOrganisationQuestionsProps) => {
    return await supabase
        .from('question_bank')
        .select('*')
        .eq('organisation_id', organisation_id)
        .eq('crm_id', crm_id)
        .throwOnError()
        .then(res => res.data);
}
